export const FORMS_APP_DEF_ID = '14ce1214-b278-a7e4-1373-00cebd1bef7c'
export const FORMS_WIDGET_ID = 'init-phase'
